<template>
  <div class="edit-habit flex flex-col justify-between">
    <div>
      <header class="mint-header flex justify-between">
        <router-link to="/habits" class="justify-self-start">
          <i class="material-icons">arrow_back_ios_new</i>
        </router-link>
        <span @click="deleteConfirmation" class="cursor-pointer"
          >Delete Habit</span
        >
      </header>

      <template>
        <div class="w-full flex justify-center px-2 mt-4">
          <t-select v-model="usingExistingCategory" :options="options" />
        </div>
        <mt-field
          v-if="isCreateNewCategory"
          label="Category:"
          placeholder="e.g. Morning Ritual"
          v-model="habitCategory"
          @input="reset"
          class="w-full mt-2 category"
          :state="categoryValidation"
        ></mt-field>
        <mt-field
          v-else
          label="Category:"
          placeholder="e.g. Morning Ritual"
          v-model="usingExistingCategory"
          @input="reset"
          class="w-full mt-2 category"
          :state="categoryValidation"
        ></mt-field>
      </template>

      <mt-field
        label="Name:"
        placeholder="e.g. Full body stretching"
        v-model="habitName"
        @input="reset"
        :state="nameValidation"
      ></mt-field>
      <mt-field
        label="Description:"
        placeholder="e.g. Listen to podcast"
        v-model="habitDescription"
        @input="reset"
      ></mt-field>

      <div class="flex justify-center mt-10">
        <div>
          <t-toggle v-model="habitIsPositive" class="" />
        </div>
        <span
          class="ml-3"
          :class="habitIsPositive ? 'text-success' : 'text-warning'"
          >{{ habitIsPositive ? 'Positive' : 'Negative' }} Habit!</span
        >
      </div>
    </div>

    <div class="flex justify-center p-10">
      <t-button
        @click="save"
        :variant="{
          success: isSaved,
          error:
            categoryValidation === 'warning' || nameValidation === 'warning'
        }"
      >
        {{ isSaved ? 'Saved' : 'Save' }}
      </t-button>
    </div>
  </div>
</template>

<script>
import userModule from '@/store/modules/user.module'
import categoryModule from '@/store/modules/category.module'
import habitModule from '@/store/modules/habit.module'
import { MessageBox, Toast } from 'mint-ui'

export default {
  name: 'EditHabit',

  data() {
    return {
      habitId: '',
      habitName: '',
      habitIsPositive: false,
      habitDescription: '',
      habitCategory: '',
      habitMonthCreated: 0,
      habitYearCreated: 0,
      habitSubIndex: 0,
      habitAllIndex: 0,
      usingExistingCategory: '',
      isSaved: false,
      nameValidation: '',
      categoryValidation: '',
      originalCategory: ''
    }
  },

  computed: {
    user: userModule.user,
    categories: categoryModule.categories,

    isCreateNewCategory() {
      return this.usingExistingCategory === 'Create New Category'
    },

    options() {
      const categories = Array.from(this.categories)
      categories.unshift('Create New Category')
      return categories
    }
  },

  methods: {
    save() {
      const habitCategory = this.isCreateNewCategory
        ? this.habitCategory
        : this.usingExistingCategory
      const isNameValid = this.validateName()
      const isCategoryValid = this.validateCategory(habitCategory)
      if (!isNameValid || !isCategoryValid) return

      const habit = {
        name: this.habitName,
        isPositive: this.habitIsPositive,
        description: this.habitDescription,
        category: habitCategory,
        monthCreated: this.habitMonthCreated,
        yearCreated: this.habitYearCreated,
        subIndex: this.habitSubIndex,
        allIndex: this.habitAllIndex,
        userId: this.user.id,
        id: this.habitId
      }

      habitModule.updateHabit(habit, this.originalCategory)

      this.categories.add(habitCategory)
      this.isSaved = true
      setTimeout(() => this.$router.push({ name: 'Habits' }), 800)
    },

    validateCategory(habitCategory) {
      const createNewCategoryEmpty =
        this.isCreateNewCategory && this.habitCategory === ''
      const usingExistingCategoryEmpty =
        !this.isCreateNewCategory && this.usingExistingCategory === ''
      if (createNewCategoryEmpty || usingExistingCategoryEmpty) {
        this.categoryValidation = 'warning'
        return false
      }

      return true
    },

    validateName() {
      if (this.habitName === '') {
        this.nameValidation = 'warning'
        return false
      }

      return true
    },

    reset() {
      this.nameValidation = ''
      this.categoryValidation = ''
      this.isSaved = false
    },

    deleteConfirmation() {
      MessageBox({
        title: 'Are you sure?',
        message: 'This will delete the habit and its logs',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Nuke it'
      }).then(action => {
        if (action === 'cancel') return
        this.deleteHabit()
        Toast({
          message: 'Habit deleted',
          position: 'middle',
          duration: 1000
        })
        this.$router.push({ name: 'Habits' })
      })
    },

    deleteHabit() {
      habitModule.resetHabitsOrder(this.habitId, this.originalCategory)
      this.$store.dispatch('deleteHabit', {
        habitId: this.habitId,
        category: this.originalCategory
      })
    }
  },

  mounted() {
    const habit = this.$route.params.habit
    this.habitId = habit.id
    this.habitName = habit.name
    this.habitIsPositive = habit.isPositive
    this.habitDescription = habit.description
    this.habitMonthCreated = habit.monthCreated
    this.habitYearCreated = habit.yearCreated
    this.habitSubIndex = habit.subIndex
    this.habitAllIndex = habit.allIndex
    this.usingExistingCategory = habit.category
    this.originalCategory = habit.category
  }
}
</script>

<style lang="scss" scoped>
.edit-habit {
  height: calc(100vh - 62px);
}
.text-warning {
  color: rgb(255, 186, 0);
}
.text-success {
  color: #68d391;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='%23000000'><polygon points='0,0 100,0 50,50'/></svg>")
    no-repeat;
  background-size: 10px;
  background-position: right 0.5em top 60%;
  background-repeat: no-repeat;
  background-color: #ffffff;
}
</style>
